export type Node = {
    type: Selection;
    id: number;
    name: string;
    children: NodeGroup[];
};

// Org Tree
// NODE: Company1
//      GROUP: Locations
//              NODE: Location1
//              NODE: Location2
//      GROUP: Resellers
//              NODE: Reseller1
//                      GROUP: Locations
//                              NODE: Location3
//                              NODE: Location4
//              NODE: Reseller2
//                  etc.
export type NodeGroup = {
    nodesType: Selection;
    type: GroupType;
    name: string;
    nodes: Node[];
};

export enum Selection {
    Company = 'company',
    Reseller = 'reseller',
    Location = 'location',
}

export enum GroupType {
    Resellers = 'resellers',
    Locations = 'locations',
    ResellerLocations = 'resellerLocations',
}
